'use client';

import React, { useState, useEffect } from 'react';
import AppLogo from '@/components/ui/AppLogo';

interface HeaderProps {
  onBookNow?: () => void;
}

export default function Header({ onBookNow }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-40 transition-all duration-500"
      style={{
        background: scrolled
          ? 'rgba(11,11,15,0.92)'
          : 'transparent',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(139,105,20,0.18)' : 'none',
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <AppLogo
          src="/assets/images/ChatGPT_Image_Aug_7__2026__05_33_41_PM-1786149255665.png"
          text="REGAL PORTRAITS"
          size={40}
          className="font-display font-black tracking-[0.25em] text-xl"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        />

        <nav className="hidden md:flex items-center gap-10">
          {[
            { label: 'Packages', href: '#packages' },
            { label: 'About', href: '#about' },
            { label: 'Contact', href: '#contact' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-[10px] font-bold uppercase tracking-[0.3em] transition-colors duration-200"
              style={{ color: 'rgba(232,228,220,0.5)' }}
              onMouseEnter={(e) => ((e.target as HTMLAnchorElement).style.color = '#D4A843')}
              onMouseLeave={(e) => ((e.target as HTMLAnchorElement).style.color = 'rgba(232,228,220,0.5)')}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          className="btn-gold hidden md:block"
          onClick={() => {
            const el = document.getElementById('packages');
            el?.scrollIntoView({ behavior: 'smooth' });
          }}
        >
          <span>View Packages</span>
        </button>

        <button
          className="btn-gold hidden md:block"
          onClick={onBookNow}
        >
          <span>Book Now</span>
        </button>

        {/* Mobile menu toggle */}
        <button
          className="md:hidden flex flex-col gap-[5px] p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {[0, 1, 2].map((i) => (
            <span
              key={i}
              className="block h-px w-6 transition-all duration-300"
              style={{
                background: '#D4A843',
                opacity: menuOpen && i === 1 ? 0 : 1,
                transform:
                  menuOpen
                    ? i === 0
                      ? 'rotate(45deg) translateY(8px)'
                      : i === 2
                      ? 'rotate(-45deg) translateY(-8px)'
                      : 'none' :'none',
              }}
            />
          ))}
        </button>
      </div>

      {/* Mobile nav */}
      <div
        className="md:hidden overflow-hidden transition-all duration-500"
        style={{
          maxHeight: menuOpen ? '300px' : '0',
          background: 'rgba(11,11,15,0.97)',
          borderBottom: menuOpen ? '1px solid rgba(139,105,20,0.18)' : 'none',
        }}
      >
        <div className="px-6 py-6 flex flex-col gap-6">
          {[
            { label: 'Packages', href: '#packages' },
            { label: 'About', href: '#about' },
            { label: 'Contact', href: '#contact' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-xs font-bold uppercase tracking-[0.3em]"
              style={{ color: 'rgba(232,228,220,0.6)' }}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <button className="btn-gold w-fit mt-2">
            <span>View Packages</span>
          </button>
          <button
            className="btn-gold w-fit mt-2"
            onClick={() => { setMenuOpen(false); onBookNow?.(); }}
          >
            <span>Book Now</span>
          </button>
        </div>
      </div>
    </header>
  );
}